// Copyright ©️ 2026 eVolve MEP, LLC

import { graphlib, layout } from '@dagrejs/dagre';
import type { Edge, Node } from '@xyflow/react';

import { maxTaskNodeWidth, partNodeHeight, taskNodeHeight } from 'modules/Shop/CatalogSetup/PartEditor/nodes/constants';

export const autoLayoutedNodes = (nodes: Node[], edges: Edge[]): Node[] => {
  const dagreGraph = new graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({ rankdir: 'LR' });
  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, {
      width: maxTaskNodeWidth * (3 / 4),
      height: taskNodeHeight,
    });
  });
  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });
  layout(dagreGraph);
  return nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id) as { x: number; y: number };
    return {
      ...node,
      position: {
        x: nodeWithPosition.x - maxTaskNodeWidth / 2,
        y: nodeWithPosition.y - (node.type === 'task' ? taskNodeHeight : partNodeHeight) / 2,
      },
    };
  });
};
